import React, {Component} from 'react';
import "../../../../css/pages/admin/components/CalendarView.css";
import CalendarMonth from "./CalendarMonth";
import Button from "@material-ui/core/Button";
import {PostWithAuth} from "../../../api/client/Post";


class CalendarView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            monthData: props.monthData
        }
    }

    static shouldComponentUpdate(nextProps, nextContext) {
        this.setState({
            monthData: nextProps.monthData
        });
    }

    handleMonthChange = (yearMonth, bitmap) => {
        let {monthData} = this.state;

        for (let i = 0; i < monthData.length; i++) {
            if (monthData[i].yearMonth === yearMonth) {
                monthData[i].bitmap = bitmap;
                break;
            }
        }

        this.setState({
            monthData: monthData
        })
    };

    saveCalendar = () => {
        // let modifiedMonths = this.state.monthData.filter((m) => m.modified);
        let roomId = this.props.roomId;

        PostWithAuth("/api/admin/calendar/" + roomId, this.state.monthData, this.props.token)
            .then((res) => {
                this.setState({
                    uploadMessage: res.data
                })
        }).catch(error => alert(error));
    };

    render() {
        return (
            <React.Fragment>
                <h3>Room {this.props.roomId}</h3>
                {
                    this.state.monthData.slice(0, 3).map(m => <CalendarMonth data={m} key={"cal-mnth-" + m.yearMonth}
                                                                             onDataChange={this.handleMonthChange}/>)
                }
                <br/>
                {
                    this.state.monthData.slice(3, 6).map(m => <CalendarMonth data={m} key={"cal-mnth-" + m.yearMonth}
                                                                             onDataChange={this.handleMonthChange}/>)
                }
                <br/>
                <Button variant="outlined" onClick={this.saveCalendar}>
                    Submit
                </Button>
                <h3>
                    {this.state.uploadMessage}
                </h3>
            </React.Fragment>
        );
    }

}

export default CalendarView;
